import { initContract } from "@ts-rest/core";
import { adpRunCreateConnectionBodySchema } from "@common/schemas/domains/adpRun/adp-run-connection.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { integrationConnectionWithAccountsResponseSchema } from "@common/schemas/domains/integrationConnection/integration-connection-response.schema";

const c = initContract();

export const adpRunIntegrationContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: adpRunCreateConnectionBodySchema,
            responses: {
                200: integrationConnectionWithAccountsResponseSchema,
                201: integrationConnectionWithAccountsResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/adp-run",
    },
);
